export default __webpack_public_path__ + "static/media/8.ff0ec9c0.jpg";